import technicalManagementService from '../services/technical-management.service';

export const technicalManagement = {
  namespaced: true,
  state: {
    statusControl: [],
    showSidebarStatusControl: false,
  },
  getters: {
    listStatusControl: state => state.statusControl,
    showSidebarStatusControlPatIndicator: state => state.showSidebarStatusControl,
  },
  actions: {
    async fetchStatusControl({ commit }) {
      try {
        const params = {
          confirmed: 0,
        };
        const response = await technicalManagementService.getPatStatusControl(params);
        commit('setList', response.data);
        return Promise.resolve(response.data);
      } catch (error) {
        commit('fetchError');
        return Promise.reject(error);
      }
    },
    toggleSidebarStatusControl({ commit }, show) {
      commit('setSidebarStatusControl', show);
    }
  },
  mutations: {
    setList(state, list) {
      state.statusControl = list;
    },
    setSidebarStatusControl(state, show) {
      state.showSidebarStatusControl = show;
    },
    fetchError(state) {
      state.statusControl = [];
    },
    clear(state) {
      state.statusControl = [];
    }
  }
};
